/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const STORE_TOKEN = 'StoreToken:CatalogToken';

export const SEO_ESCAPE_CHAR = '\u200B'; // zero-width space character to prevent SEO scraping

export const SEO_OBFUSCATION_FIELDS = [
	//'href',
	'parentCatalogGroupID',
/* 	'thumbnail',
	'thumbnailRaw',
	'next',
	'previous',
	'fullImage', 
	'fullImageRaw',
	'parent',
	'image1',
	'image1path',
	'attachmentAssetPath',
	'trail',
	'url',
	'contentUrl', */
	'resourceId',	
];
